// theme-sources/js/sections/testimonials.jsconst DEBUG = true;

const DEBUG = false;
const logger = {
  info(message, payload) {
    if (typeof window === "undefined") return;
    if (window.__ZIGGY_DEBUG__ !== true) return;
    if (!DEBUG) return;
    console.info(`[Testimonials] ${message}`, payload ?? "");
  },
};

const ACTIVE_AVATAR_CLASSES = ["h-22", "w-22", "opacity-100", "text-primary"];
const INACTIVE_AVATAR_CLASSES = ["h-15", "w-15", "opacity-40"];
const DIM_BUTTON_CLASS = "opacity-40";

function initTestimonials(root = document) {
  root.querySelectorAll("[data-testimonials]").forEach(initOne);
}

function initOne(root) {
  const count = Number(root.dataset.count) || 0;
  if (count <= 1) return;

  logger.info("init", { count });

  const state = {
    active: 1, // correspond au first visible
    count,
  };

  const scroller = root.querySelector(".testi_scroller");
  const prevBtn = root.querySelector("[data-testimonials-prev]");
  const nextBtn = root.querySelector("[data-testimonials-next]");
  const testimonials = Array.from(root.querySelectorAll("[data-testimonial]"));
  const metas = Array.from(root.querySelectorAll("[data-meta]"));
  const avatars = Array.from(root.querySelectorAll("[data-avatar]"));

  if (!testimonials.length) {
    logger.warn("no testimonials found");
    return;
  }

  function setButtonDisabled(btn, disabled) {
    if (!btn) return;
    btn.disabled = disabled;
    btn.classList.toggle(DIM_BUTTON_CLASS, disabled);
  }

  function setAvatarActive(btn, isActive) {
    btn.classList.remove(...ACTIVE_AVATAR_CLASSES, ...INACTIVE_AVATAR_CLASSES);
    btn.classList.add(
      ...(isActive ? ACTIVE_AVATAR_CLASSES : INACTIVE_AVATAR_CLASSES),
    );
  }

  function updateTestimonials() {
    testimonials.forEach((el) => {
      const idx = Number(el.dataset.index);
      el.hidden = idx !== state.active;
    });
  }

  function updateMetas() {
    metas.forEach((el) => {
      const idx = Number(el.dataset.index);
      el.hidden = idx !== state.active;
    });
  }

  function updateAvatars() {
    avatars.forEach((btn) => {
      const idx = Number(btn.dataset.index);
      setAvatarActive(btn, idx === state.active);
    });
  }

  function updateScroller() {
    if (!scroller) return;
    if (state.active <= 2) {
      scroller.style.transform = "translateX(0)";
    } else {
      scroller.style.transform = `translateX(calc(-7rem * ${state.active - 2}))`;
    }
  }

  function updateButtons() {
    setButtonDisabled(prevBtn, state.active <= 1);
    setButtonDisabled(nextBtn, state.active >= state.count);
  }

  function update() {
    updateTestimonials();
    updateMetas();
    updateAvatars();
    updateScroller();
    updateButtons();
  }

  function goTo(index) {
    const next = Math.max(1, Math.min(state.count, index));
    if (next === state.active) return;
    state.active = next;
    update();
  }

  prevBtn?.addEventListener("click", () => goTo(state.active - 1));
  nextBtn?.addEventListener("click", () => goTo(state.active + 1));

  avatars.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      goTo(Number(btn.dataset.index));
    });
  });

  // état initial
  update();
}

// auto-init (section JS)
initTestimonials();
